import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { selectedLangAtom } from '../state/atoms';

function useLanguageLocale() {
  const [selectedLocale] = useRecoilState(selectedLangAtom);
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = selectedLocale;
    const lang = locale?.split('-')[0] || 'en';

    i18n.changeLanguage(lang);
  }, [i18n, selectedLocale]);
}

export default useLanguageLocale;
